module.exports = __webpack_public_path__ + "img/3.96fa375f.jpeg";